import React from 'react';
import { withTheme } from 'styled-components';
import { transparentize } from 'utils/color';
import { Figure } from './Figure.styled';

type CourseFailedBackgroundProps = {
  theme: { [key: string]: any };
};
export const CourseFailedBackground = (props: CourseFailedBackgroundProps) => (
  <Figure
    width="260px"
    height="75px"
    viewBox="0 0 260 75"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
  >
    <defs>
      <filter
        id="prefix__a"
        width="100%"
        height="100%"
        x="0%"
        y="0%"
        filterUnits="objectBoundingBox"
      >
        <feGaussianBlur in="SourceGraphic" />
      </filter>
    </defs>
    <path
      fill={transparentize(props.theme.colors.textColor, 1.0)}
      fillRule="evenodd"
      d="M74.48.423H20.984s-9.378 1.012-9.378 8.467c0 7.454 9.378 8.466 9.378 8.466l31.828.06s7.447 1.452 7.447 7.983c0 6.53-7.447 
      8.466-7.447 8.466H36.368s-13.348.815-13.348 8.89c0 8.074 13.348 9.312 13.348 9.312H9.479S0 53.7 0 60.473C0 67.246 9.48 69 9.48 
      69h207.865s11.703-1.33 11.703-8.527c0-7.196-11.703-8.406-11.703-8.406H197.02s-11.868-.707-12.08-8.042c-.211-7.336 12.08-8.709 
      12.08-8.709l23.586-.816s12.31 1.814 12.31-8.376-11.325-8.768-11.325-8.768l28.253.06S260 16.806 260 8.89C260 .973 249.844 0 249.844 0L74.479.423z"
      filter="url(#prefix__a)"
      opacity=".02"
      transform="translate(0 6)"
    />
  </Figure>
);
export default withTheme(CourseFailedBackground);
